import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './MainLayout.css';

/**
 * Abaixo de 1200px o CSS trata a barra lateral como camada sobreposta, e não
 * como coluna ao lado do conteúdo.
 */
const ESTREITO = '(max-width: 1199px)';

export default function MainLayout() {
  /*
   * A barra nasce fechada em tela estreita.
   *
   * Nascendo aberta, ela cobria o conteúdo antes de qualquer interação: 69% da
   * tela num celular e 26% num iPad, que é onde o operador de central 24h
   * trabalha. Não era um detalhe de layout — a pessoa abria o sistema e via a
   * própria navegação por cima daquilo que veio consultar, todo dia, tendo que
   * fechar na mão antes de começar.
   */
  const [sidebarOpen, setSidebarOpen] = useState(() =>
    typeof window === 'undefined' ? true : !window.matchMedia(ESTREITO).matches,
  );
  const local = useLocation();

  /*
   * Escolher um item fecha a barra no celular.
   *
   * Como ali ela é sobreposição, continuar aberta depois do clique esconde
   * justamente a tela que a pessoa acabou de pedir. Em tela larga não há o que
   * fechar: a barra é uma coluna e o conteúdo tem lugar próprio.
   */
  useEffect(() => {
    if (window.matchMedia(ESTREITO).matches) setSidebarOpen(false);
  }, [local.pathname]);

  // Girar o aparelho ou redimensionar a janela cruza o limiar: sem isto, a
  // barra fica no estado da largura anterior.
  useEffect(() => {
    const mq = window.matchMedia(ESTREITO);
    const aoMudar = (e) => setSidebarOpen(!e.matches);
    mq.addEventListener('change', aoMudar);
    return () => mq.removeEventListener('change', aoMudar);
  }, []);

  const estreito = typeof window !== 'undefined' && window.matchMedia(ESTREITO).matches;

  return (
    <div className={`layout ${sidebarOpen ? '' : 'sidebar-collapsed'}`}>
      <Sidebar isOpen={sidebarOpen} />

      {/* Toque fora fecha, que é o gesto esperado de uma gaveta. */}
      {sidebarOpen && estreito && (
        <div
          className="sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="layout-content">
        <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
